<template>
  <div class="mb-2">
    <b-card
      variant="light"
      align="left"
      :img-src="node.Image"
      img-top>

          <dl v-if="node.type != 'null'">
            <dt v-if="node.type && node.type=='CONCEPT' && node.id">Open:</dt>
            <dd v-if="node.type && node.type=='CONCEPT' && node.id"><a :href="node.id" target="_blank">{{node.id}}</a></dd>

            <dt v-if="node.type && node.type=='DOC' && node.id">Open search result:</dt>
            <dd v-if="node.type && node.type=='DOC' && node.id">
              <b-link href="#" v-on:click.prevent="gotoTopic(node.sem_encoded_id)">{{node.id}}</b-link>
            </dd>
<!--
            <dt v-if="node.type">Record Type</dt>
            <dd v-if="node.type">{{node.type}}</dd>
-->
            <dt v-if="node.sem_record_subtype">Subtype</dt>
            <dd v-if="node.sem_record_subtype">{{node.sem_record_subtype}}</dd>
            <dt v-if="node.url || node.sem_url">URL</dt>
            <dd v-if="node.url">
              <a :href="node.url" target="_blank">{{node.url}}</a>
            </dd>
            <dd v-if="node.sem_url">
              <a :href="node.sem_url" target="_blank">{{node.sem_url}}</a>
            </dd>
            <dt v-if="node.type == 'concept' && node.sem_abstract">Definition</dt>
            <dd v-if="node.type == 'concept' && node.sem_abstract" class="abstractmh">{{node.sem_abstract}}</dd>

            <dt v-if="node.type == 'document' && node.brief_summary">Brief summary</dt>
            <dd v-if="node.type == 'document' && node.brief_summary" class="abstractmh">{{node.brief_summary}}</dd>

            <dt>Info:</dt>
            <dd class="abstractmh">{{node.Abstract}}</dd>
          </dl>
          <dl v-else>{{node.id}}</dl>

          <b-button v-if="node.type !='null'" class="m-1 float-right" size="sm" variant="primary" v-on:click.prevent="openGraph(node.sem_encoded_id)" >
            Change to node
          </b-button>
          <b-button v-if="node.type !='null'" class="m-1 float-right" size="sm" variant="primary" v-on:click.prevent="expandNode(node.id)" >
            Expand node
          </b-button>
    </b-card>
  </div>
</template>

<script>

export default {
  name: 'nodedetail',
  data () {
    return {
    }
  },
  props: [ 'node' ],
  methods: {
    openGraph (nodeId) {
       this.$emit('nodeChanged', nodeId);
    },
    expandNode (nodeId) {
       this.$emit('nodeExpansion', nodeId);
    },
    gotoTopic (id) {
      this.$router.push({ path: '/detail/' +  id});
    }
  }
}
</script>

<style scoped>
.abstractmh {
  max-height:200px;
  overflow:scroll;
}
</style>
